import { createTheme, ThemeProvider } from "@mui/material/styles";
import * as React from "react";

type LayerThemeProviderProps = {
  children: React.ReactNode;
};

export const LayerThemeProvider = ({ children }: LayerThemeProviderProps) => {
  const theme = createTheme({
    typography: {
      fontFamily:
        "'niveau-grotesk', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    },
    palette: {
      mode: "dark",
      background: {
        default: "#FFFFFF",
        paper: "#FFFFFF",
      },
      primary: {
        main: "#FFFFFF",
      },
      divider: "#EFF1F4",
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
